import type { InspectorFieldGroup } from '@/composables/searchInspectorFieldGroups';

export interface StackableSection {
    group: InspectorFieldGroup;
    open: boolean;
    fieldCount: number;
}

/**
 * Deal the Details sections into columns, each into the column that is
 * shortest so far, keeping their order within each column.
 *
 * A section's height is estimated in rows: one for its header, plus one per
 * field when it is open. For example, with "Now playing" collapsed (1 row) on
 * the left and "Playback settings" open with 16 fields (17 rows) on the right,
 * "Content and downloads" goes on the left, right under "Now playing". In a
 * grid it waited for the next row, below "Playback settings", and left a gap.
 */
export function stackSections(sections: StackableSection[], columnCount: number): InspectorFieldGroup[][] {
    const stacks: InspectorFieldGroup[][] = Array.from({ length: Math.max(1, columnCount) }, () => []);
    const heights = stacks.map(() => 0);
    for (const section of sections) {
        const shortest = heights.indexOf(Math.min(...heights));
        stacks[shortest].push(section.group);
        heights[shortest] += 1 + (section.open ? section.fieldCount : 0);
    }
    return stacks.filter((stack, index) => index === 0 || stack.length > 0);
}
